<template>
    <div class="report-middle-section p-1" :class="{ 'bg-yellow-200 border-yellow-400' : outlier }">
        <h4 class="text-center pt-0 mt-0">{{ name }}</h4>

        <div class="sr-only">
            <ul>
                <li>Trait score: {{ score }}</li>
                <li>Trait spread: {{ spread_left_integer }} to {{ spread_right_integer }}</li>
                <p v-if="score < spread_left_integer">The trait score falls below the typical spread.</p>
                <p v-else-if="score > spread_right_integer">The trait score falls above the typical spread.</p>
            </ul>
        </div>

        <div class="border-gray-750 border-4">

            <div class="sterlingbars-wrapper">
                <h5 v-if="dominant == lefttitle" class="endtitle endtitle-left text-black bg-indigo-200 font-bold">{{ lefttitle }}</h5>
                <h5 v-else class="endtitle endtitle-left font-normal">{{ lefttitle }}</h5>

                <div class="trait-wrapper">
                    <div class="trait-bar">
                        <div class="trait-score" :style="{ left: percentagescore }">
                            <!-- {{ score }} -->
                        </div>

                        <div v-if="std" class="trait-spread" :style="{ width: spreadwidth, left: spreadleft }"> &nbsp;
                        </div>
                    </div>
                </div>

                <h5 v-if="dominant == righttitle" class="endtitle endtitle-right text-black bg-indigo-200 font-bold">{{ righttitle }}</h5>

                <h5 v-else class="endtitle endtitle-right font-normal"> {{ righttitle }}</h5>
            </div>

            <div class="flex">
                <div v-if="dominant == lefttitle" class="w-1/2 enddesc enddesc-left bg-indigo-200 text-black font-normal">
                    {{ leftdesc }}
                </div>

                <div v-else class="w-1/2 enddesc enddesc-left">
                    {{ leftdesc }}
                </div>

                <div v-if="dominant == righttitle" class="w-1/2 enddesc enddesc-right bg-indigo-200 text-black font-normal">
                    {{ rightdesc }}
                </div>

                <div v-else class="w-1/2 enddesc enddesc-right">
                    {{ rightdesc }}
                </div>
            </div>
        </div>
    </div>
</template>
<!-- For Yellow Bars - IF( (userScore<(avg-std) OR userScore>(avg+std) ) -->
<script>
export default {

    props: {
        name: '',
        avg: '',
        std: '',
        score: '',
        lefttitle: '',
        leftdesc: '',
        righttitle: '',
        rightdesc: '',
        dominant: '',
    },
    data() {
        return {
            avgFloat: parseFloat(this.avg),
            stdFloat: parseFloat(this.std)
        }
    },
    computed: {
        percentagescore : function() {
            return (this.score) + '%';
        },
        spreadwidth : function() {
            return (this.std) * 2 + '%';
        },
        spreadleft : function() {
            return (this.avg) - (this.std) + '%';
        },
        spread_left_integer : function() {
            return parseInt(this.avgFloat - this.stdFloat);
        },
        spread_right_integer : function() {
            return parseInt(this.avgFloat + this.stdFloat);
        },
        outlier : function() {
            return (this.score) < (this.avgFloat - this.stdFloat) || (this.score) > (this.avgFloat + this.stdFloat);
        }
    },

};
</script>
